
import { Box, Checkbox, FormControlLabel } from '@mui/material'; // ⬅️ add Checkbox
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useEffect } from 'react';
import BaseCard from '../../../components/Cards/Card';
import CustomEmailInput from '../../../components/EmailInput';
import CustomPasswordInput from "../../../components/PasswordInput";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { BASE_URL } from "../../../components/BaseUrl";
import { apiPost } from "../../../utils/apiService";
import { useDispatch } from 'react-redux';
import { setCredentials, setProfileUpdateToken } from '../../../Redux/Slices/AuthSlice';
import InvalidOtpModal from '../Registeration/InvalidOtpErrorScreen';
import PasswordNotSetModal from './PasswordNotSetModal';
import ProfileIncompleteModal from './ProfileIncompleteModal';
import { useLocation } from 'react-router-dom';
const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate()
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
const [showInvalidOtpModal, setShowInvalidOtpModal] = useState(false);
const [pendingEmail, setPendingEmail] = useState("");
const [pendingMessage, setPendingMessage] = useState(""); // ✅ new state
const [showPasswordNotSetModal, setShowPasswordNotSetModal] = useState(false);
const [showProfileIncompleteModal, setShowProfileIncompleteModal] = useState(false);
const [profileStatusData, setProfileStatusData] = useState(null);
const location = useLocation();

const fromWebsite = new URLSearchParams(location.search).get("fromWebsite") === "true";
      useEffect(() => {
    const saved = localStorage.getItem("credentials");
    if (saved) {
      const { email, password } = JSON.parse(saved);
      formik.setFieldValue("email", email);
      formik.setFieldValue("password", password);
      setRememberMe(true);
    }
  }, []);

  const validate = (values) => {
    const errors = {};

    // Email validation
    if (!values.email) {
      errors.email = t('login.emailRequired');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = t('login.emailInvalid');
    }

    // Password validation
  if (!values.password) {
  errors.password = t('login.passwordRequired');
}

    return errors; // 🔴 This and closing bracket were missing
  };


const syncPaypalSubscription = async (token) => {
  try {
    console.log("⚙️ Sync PayPal subscription starting...");

    const alreadySynced = localStorage.getItem("paypalSynced");
    if (alreadySynced) {
      console.log("⏩ PayPal sync skipped (already synced)");
      return;
    }

    console.log("📡 Calling sync API with token:", token?.slice(0, 10) + "...");

    const res = await fetch(`${BASE_URL}/payments/company-admin/sync-paypal-subscription`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const json = await res.json();
    console.log("🔄 PayPal sync result:", json);

    if (!res.ok || json.error) throw new Error(json.message || "Sync failed");
    localStorage.setItem("paypalSynced", "true");
    console.log("✅ PayPal sync completed successfully");
  } catch (err) {
    console.error("❌ PayPal sync error:", err.message);
  }
};



  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validate,
    onSubmit: async (values) => {
      const errors = validate(values);
      if (Object.keys(errors).length > 0) {
        // Show first error
        if (errors.email) toast.error(errors.email);
        else if (errors.password) toast.error(errors.password);
        return;
      }

      setLoading(true);
      try {
        // apiPost localizes `message` to message_es/message_en based on the
        // current UI language — a plain fetch() would only ever return English.
        const data = await apiPost(`${BASE_URL}/company-admins/login`, values);
        console.log(data)
        if (data.data?.upgrade_required || data.status === 402) {
          if (data.data?.upgrade_token) {
            localStorage.setItem("subscriptionUpgradeToken", data.data.upgrade_token);
          }
          setPendingMessage(data.message || data.data?.message);
          toast.error(data.message || "Your subscription has expired.");
          if (data.data?.upgrade_link) {
            window.location.href = data.data.upgrade_link;
          }
          return;
        }
if (data.data?.requiresApproval) {
  navigate("/admin-approval", {
    state: { message: data.data.message } // 👈 pass message here
  });
  return;
}


if (data.data?.passwordNotSet) {  // adjust key based on your backend error
  setPendingEmail(values.email);
  setPendingMessage(data.message);
  setShowPasswordNotSetModal(true);
  return;
} 
if (data.data?.requiresVerification) {
  setPendingEmail(values.email);
  setShowInvalidOtpModal(true);
    setPendingMessage(data.message || data.data?.message);
// 👈 open modal instead of navigate
  return;
}

// Login response indicates the company profile setup isn't finished yet
if (data.data?.status === "profile_incomplete") {
  // Screens like CreateProfile/Locations read this key for their setup-complete-profile call
  if (data.data.token) {
    localStorage.setItem("profileUpdateToken", data.data.token);
    dispatch(setProfileUpdateToken(data.data.token));
  }

  setProfileStatusData(data.data);
  setShowProfileIncompleteModal(true);
  return;
}

      if (!data.ok || data.error) {
          throw new Error(data.message || "Login failed");
        }

    

        console.log("Original token:", data.data);


           if (rememberMe) {
        localStorage.setItem("credentials", JSON.stringify(values));
      } else {
        localStorage.removeItem("credentials");
      }
        dispatch(setCredentials({ token: data.data.token, user: data.data.user,    company: data.data.company,
           trialInfo: data.data.trial_info || null,   // 👈 store company info
 }));

        // toast.success(t("login.loginSuccess"));
console.log("🧾 Token before sync:", data.data.token);
await syncPaypalSubscription(data.data.token);
setTimeout(() => {
  if (fromWebsite) {
    navigate("/subscription-plans", {
      state: { activeTab: "upgrade_plans" }
    });
  } else {
    navigate("/dashboard");
  }
}, 1500);
      } catch (error) {
        toast.error(error.message || "login.loginFailed");
      } finally {
        setLoading(false); // Stop loader
      }
    }
  });



  const handleForget = () => {
    navigate("/forget-password")
  }

  return (
    <Box sx={{ backgroundColor: "#EFF4F8", 
       display: 'flex', justifyContent: 'center',alignItems:"center" ,
         minHeight: "100vh", mt: isMobile?2:0, pt: 0 , py: isMobile ? 5 : 10, px: 2,}}>


        <BaseCard
          maxWidth={isMobile ? '100%' : 380}
          sx={{
            width: isMobile ? '100%' : 'auto',
            boxSizing: 'border-box',
            px: isMobile ? 1 : 0,
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, mb: 2 }}>
                <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main, letterSpacing: "0px !important" }}>
                  {t('login.title')}
                </CustomText>
                <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary, letterSpacing: "0px !important" }}>
                  {t('login.subtitle')}
                </CustomText>
              </Box>

              <label className='email_label'>{t('login.emailLabel')}</label>
              <CustomEmailInput
                name="email"
                placeholder="john@gmail.com"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email}
              />
              {formik.touched.email && formik.errors.email && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.email}</span>
              )}

              <label>{t('login.passwordLabel')}</label>
              <CustomPasswordInput
              placeholder='********'
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && formik.errors.password}
              />
              {formik.touched.password && formik.errors.password && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.password}</span>
              )}


              {/**/}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      size="small"
                      sx={{ p: 0, mr: 1 }} // remove extra padding, keep small gap
                    />
                  }
                  label={
                    <CustomText sx={{ ...textStyles.body4, fontWeight: 400, color: theme.palette.text.primary }}>
                      {t("login.rememberMe")}
                    </CustomText>
                  }
                />
              <Box sx={{ }}>
                <CustomText sx={{ ...textStyles.body4, fontWeight: 400, color: theme.palette.primary.main, cursor: "pointer", letterSpacing: "0px !important" }} onClick={handleForget}>
                  {t('login.forgotPassword')}
                </CustomText>
              </Box> 
              </Box>

              <CustomButton
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    {loading && (
                      <CircularProgress
                        size={18}
                        sx={{ color: '#fff', mr: 1 }}
                      />
                    )}
                    {t('login.loginButton')}
                  </Box>
                }
                type="submit"
                fullWidth
                sx={{ mt: 2 }}
              />
            </Box>
          </form>
        </BaseCard>
        <InvalidOtpModal
  open={showInvalidOtpModal}
  onClose={() => setShowInvalidOtpModal(false)}
  email={pendingEmail}
    message={pendingMessage}
/>
<PasswordNotSetModal
  open={showPasswordNotSetModal}
  onClose={() => setShowPasswordNotSetModal(false)}
  email={pendingEmail}
  message={pendingMessage}
/>
<ProfileIncompleteModal
  open={showProfileIncompleteModal}
  onClose={() => setShowProfileIncompleteModal(false)}
  profileStatus={profileStatusData}
/>



    </Box>
  );
};

export default Login;

